import { currentTraits } from './current';
import type { InputTraits } from './traits';

/**
 * **起拖 / 起点的位移阈值（CSS px）。**
 *
 * 鼠标可以很小（精准），手指要大一点（指腹会抖，太小会把“点一下”误判成“拖”）。
 * 阈值随 `InputTraits.finePointer` / `contactPx` 走 —— 不是“触屏模式”。
 */
export function dragSlop(traits: InputTraits = currentTraits()): number {
  if (traits.finePointer) return 5;
  // 接触面越大给越多容忍，上限 20
  return Math.min(20, 10 + traits.contactPx * 0.25);
}

/** 位移有没有超过起拖阈值 */
export function exceedsDragSlop(
  dx: number,
  dy: number,
  traits: InputTraits = currentTraits(),
): boolean {
  return Math.hypot(dx, dy) > dragSlop(traits);
}
